"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLinkOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M29.24 6.76a6 6 0 00-8.48 0l1.42 1.41a4.09 4.09 0 015.65 0 4 4 0 010 5.65l-7.54 7.47a4 4 0 01-5.7-5.6l1.07-.94-1.32-1.5-1.11 1a6 6 0 004.24 10.23 5.94 5.94 0 004.23-1.75l7.54-7.47a6 6 0 000-8.48z" }),
        React.createElement("path", { d: "M4.17 24.83a4 4 0 010-5.65l7.6-7.63a4.09 4.09 0 015.65 0 4 4 0 010 5.64l-1.13 1.09 1.38 1.44 1.15-1.1a6 6 0 000-8.48 6 6 0 00-8.48 0l-7.6 7.62A6 6 0 007 28a5.91 5.91 0 004.24-1.76l-1.42-1.41a4.09 4.09 0 01-5.65 0z" })));
}
exports.default = SvgLinkOutline;
//# sourceMappingURL=LinkOutline.js.map